<template>
  <div class="accordion-btn-base" :class="{open: isOpen}" @click="onBtnClick">
    <div class="btn-wrap">
      <link-icon :is-playlist-text-menu="true" :is-opened="isOpen" />
    </div>
  </div>
</template>

<script>
import LinkIcon from '@/utvStore/components/partials/LinkIcon'
export default {
  name: 'AccordionBtn',
  components: {
    LinkIcon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    onBtnClick(){
      this.$emit('accbtn-click')
    }
  }
}</script>

<style scoped lang="scss">
.accordion-btn-base {
  width: 100%;
  display: flex;
  justify-content: right;
}
.btn-wrap {
  padding: 8px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/partials/AccordionBtn.vue